import "core-js/stable";
import "regenerator-runtime/runtime";

import "./css/site.css";
import { createApp } from "vue";
import App from "./MfMiniSiteApp.vue";
import router from "./router/mfmini-router";
import appFilters from "./func/appFilters";
import { siteUser, userLoadStatus } from "./state/appState";
  
const app = createApp(App);
app.config.globalProperties.$filters = appFilters;
app.config.globalProperties.$currentUser = siteUser;
app.config.globalProperties.$userLoadStatus = userLoadStatus;
app.use(router).mount("#mfminisite-app");

__webpack_public_path__ =
  process.env.NODE_ENV == "production" ? "/mfmini/" : "/mfminidev/";
